const PelatihanDetails = () => {
  return (
    <section className="PelatihanDetails-container">
      <p className="PelatihanDetails-title">Digital Marketing</p>
      <img
        className="PelatihanDetails-poster"
        src="http://via.placeholder.com/1280x720"
        alt="Banner meeting"
      />
      <p className="PelatihanDetails-smallTitle">Topik</p>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
        volutpat velit quis justo volutpat, quis dapibus diam ultricies. Ut
        finibus, lorem quis pretium malesuada, quam dui gravida leo, vel
        hendrerit nibh enim non purus. Nullam malesuada eros vulputate lacus
        elementum convallis. Maecenas id mauris augue. Vestibulum mi elit,
        molestie feugiat consequat vitae, scelerisque at magna. Interdum et
        malesuada fames ac ante ipsum primis in faucibus. Duis tempus fermentum
        nunc, sit amet tincidunt augue rhoncus vel.
      </p>

      <hr className="HR-pembagiContent" />

      <div className="PelatihanDetails-tanggal">
        <p className="PelatihanDetails-smallTitle">Tanggal: </p>
        <h5> Kamis, 24 Maret 2022</h5>
      </div>

      <hr className="HR-pembagiContent" />

      <div className="pembicara-card">
        <p className="PelatihanDetails-smallTitle">Pembicara</p>
        <div className="pembicara-top">
          <img
            className="pembicara-img"
            src="http://via.placeholder.com/200"
            alt="foto pembicara"
          />
          <div className="pembicara-profil">
            <h4 className="pembicara-nama">Nama Pembicara disini</h4>
            <h6>Expertise</h6>
            <h6>Institusi</h6>
          </div>
        </div>
        <div className="pembicara-bottom">
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
            volutpat velit quis justo volutpat, quis dapibus diam ultricies. Ut
            finibus, lorem quis pretium malesuada, quam dui gravida leo, vel
            hendrerit nibh enim non purus. Nullam malesuada eros vulputate lacus
            elementum convallis. Maecenas id mauris augue.{" "}
          </p>
        </div>
      </div>

      <hr className="HR-pembagiContent" />

      <div className="PelatihanDetails-video">
        <p className="PelatihanDetails-smallTitle">Video </p>
        <h5> link video zoom </h5>
      </div>

      <hr className="HR-pembagiContent" />

      <p className="PelatihanDetails-smallTitle">
        Pilih Anggota yang akan didaftarkan
      </p>

      <div className="PelatihanDetails-CheckBox">
        <label>
          <input type="checkbox" />
          Nama Anggota
        </label>
        <label>
          <input type="checkbox" />
          Nama Anggota
        </label>
        <label>
          <input type="checkbox" />
          Nama Anggota
        </label>
        <label>
          <input type="checkbox" />
          Nama Anggota
        </label>
        <label>
          <input type="checkbox" />
          Nama Anggota
        </label>
      </div>

      <button className="PelatihanDetailsButton">Daftar</button>
    </section>
  );
};

export default PelatihanDetails;
